/*** IMPORTS FROM imports-loader ***/
var _ = require("underscore/underscore");

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="question">\n    <div class="col-sm-4 field-text">\n    </div>\n    ';
 if(canRemove){;
__p += '\n    <div class="col-sm-2 field-category">\n    </div>\n    <div class="col-sm-3 field-type">\n    </div>\n    <div class="col-sm-3 field-options">\n        <div class="clsToggle" style="float: right"></div>\n        <div class="field-toggles btn-group btn-group-xs field-top"></div>\n    </div>\n    ';
 };
__p += '\n    <div class="options-container clearfix"></div>\n</div>';

}
return __p
}



//////////////////
// WEBPACK FOOTER
// ./public/views/layer/DataFieldEditor.ejs
// module id = 892
// module chunks = 1